module.exports = __webpack_public_path__ + "img/fedora.cdeff0b9.svg";